/**
 * Firebase configuration + session hint — intentionally free of ANY Firebase SDK import
 * so the main game bundle stays lean. `src/lib/firebase.ts` imports this file and loads
 * the SDK lazily (only for signed-in players or after an explicit sign-in click).
 */

/** Public client identifiers of the Stakko Ecosystem project (used when env vars are absent). */
const FALLBACK_CONFIG = {
  apiKey: 'AIzaSyDahWnjiCHKVcOoaPTVnGlJjegmWBxStAE',
  authDomain: 'vibiz-ecosystem.firebaseapp.com',
  databaseURL: 'https://vibiz-ecosystem-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'vibiz-ecosystem',
  storageBucket: 'vibiz-ecosystem.firebasestorage.app',
  messagingSenderId: '147334759326',
  appId: '1:147334759326:web:f9e42c6872437bfbd9cc8f',
  measurementId: 'G-TF7Q6X88V8',
};

const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : ({} as ImportMetaEnv);

export const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || FALLBACK_CONFIG.apiKey,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || FALLBACK_CONFIG.authDomain,
  databaseURL: env.VITE_FIREBASE_DATABASE_URL || FALLBACK_CONFIG.databaseURL,
  projectId: env.VITE_FIREBASE_PROJECT_ID || FALLBACK_CONFIG.projectId,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET || FALLBACK_CONFIG.storageBucket,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID || FALLBACK_CONFIG.messagingSenderId,
  appId: env.VITE_FIREBASE_APP_ID || FALLBACK_CONFIG.appId,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID || FALLBACK_CONFIG.measurementId,
};

export const CLOUD_SCHEMA = 'equity-tycoon/game';
export const CLOUD_SCHEMA_VERSION = 2;

/** Minimal user shape the app works with (Firebase-agnostic). */
export interface CloudUser {
  uid: string;
  displayName: string;
  email: string;
  photoURL: string;
  providerId: string;
}

/** Serialized match payload stored under `users/{uid}/games/activeGame`. */
export interface CloudGameDocument {
  schema: string;
  version: number;
  savedAt: number;
  round: number;
  phase: string;
  players: number;
  cleared?: boolean;
  payload: Record<string, unknown>;
}

/** True when the browser holds a persisted Firebase session (no SDK needed to check). */
export const hasPersistedSession = (): boolean => {
  try {
    return Object.keys(window.localStorage).some((key) => key.startsWith('firebase:authUser'));
  } catch {
    return false;
  }
};

/** Static config check: are the required identifiers present? */
export const isConfigPresent = (): boolean => Boolean(firebaseConfig.apiKey && firebaseConfig.projectId);
